module.exports = "<div [class]=\"cssClass\" *ngIf=\"busy\">\n\n    <div class=\"fxs-progress\" *ngIf=\"name !== 'try-functions'\">\n        <div class=\"fxs-progress-dots\">\n            <div></div><div></div><div></div>\n            <div *ngIf=\"message\">{{ message }}</div>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/busy-state/busy-state.component.html
// module id = ./src/app/busy-state/busy-state.component.html
// module chunks = main